// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ServiceConfigView.css — estilos de la vista de datos del asistente.
 *
 * Todo con variables del sistema de diseño (design-system.css) para que los
 * skins (claro/oscuro/onyx/lumina) lo sigan.
 */

.scv-root {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.scv-hint {
  margin: 0;
  font-size: 0.8rem;
  color: var(--text-secondary);
  background: var(--slate-200);
  border-left: 3px solid var(--accent);
  border-radius: 6px;
  padding: 8px 12px;
}

.scv-hint code {
  font-size: 0.78rem;
  color: var(--text-primary);
  background: var(--slate-100);
  padding: 0 4px;
  border-radius: 4px;
}

.scv-section {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 14px 16px;
}

.scv-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 10px;
}

.scv-section-icon {
  font-size: 1rem;
}

.scv-rows {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.scv-rows.is-nested {
  padding-left: 12px;
  border-left: 2px solid var(--border);
}

.scv-row {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 12px;
  align-items: baseline;
  padding: 3px 0;
  border-bottom: 1px dashed var(--border);
}

.scv-row:last-child {
  border-bottom: none;
}

.scv-key {
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.scv-val {
  font-size: 0.82rem;
  color: var(--text-primary);
  word-break: break-word;
}

.scv-chips {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
}

.scv-chip {
  font-size: 0.72rem;
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 1px 8px;
  color: var(--text-primary);
  background: var(--slate-100);
}

.scv-bool {
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 1px 8px;
}

/* Verdes/rojos seguros: se leen igual en tema claro y oscuro. */
.scv-bool.is-yes { color: #15803d; background: rgba(22, 163, 74, 0.14); }
.scv-bool.is-no  { color: #991b1b; background: rgba(220, 38, 38, 0.12); }

.scv-link {
  color: var(--accent);
  text-decoration: none;
  word-break: break-all;
}

.scv-link:hover { text-decoration: underline; }

.scv-subblock-title {
  font-size: 0.76rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 6px 0 2px;
}

.scv-sublist {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.scv-subrow {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.scv-pair {
  font-size: 0.78rem;
  color: var(--text-primary);
}

.scv-pair em {
  color: var(--text-secondary);
  font-style: normal;
}

.scv-empty-state {
  font-size: 0.82rem;
  color: var(--text-muted);
}

/* En el panel lateral del Diseñador no hay sitio: una columna. */
.sd-detail .scv-row,
.scv-compact .scv-row {
  grid-template-columns: minmax(0, 1fr);
  gap: 2px;
}

.sd-detail .scv-section,
.scv-compact .scv-section {
  padding: 10px 12px;
}

@media (max-width: 900px) {
  .scv-row { grid-template-columns: minmax(0, 1fr); gap: 2px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServiceConfigView.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE,mBAAmB,cAAc,EAAE,mCAAmC,EAAE;AACxE,mBAAmB,cAAc,EAAE,mCAAmC,EAAE;;AAExE;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,kBAAkB,0BAA0B,EAAE;;AAE9C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,iEAAiE;AACjE;;EAEE,qCAAqC;EACrC,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW,qCAAqC,EAAE,QAAQ,EAAE;AAC9D","sourcesContent":["/**\r\n * ServiceConfigView.css — estilos de la vista de datos del asistente.\r\n *\r\n * Todo con variables del sistema de diseño (design-system.css) para que los\r\n * skins (claro/oscuro/onyx/lumina) lo sigan.\r\n */\r\n\r\n.scv-root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.scv-hint {\r\n  margin: 0;\r\n  font-size: 0.8rem;\r\n  color: var(--text-secondary);\r\n  background: var(--slate-200);\r\n  border-left: 3px solid var(--accent);\r\n  border-radius: 6px;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.scv-hint code {\r\n  font-size: 0.78rem;\r\n  color: var(--text-primary);\r\n  background: var(--slate-100);\r\n  padding: 0 4px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.scv-section {\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 14px 16px;\r\n}\r\n\r\n.scv-section-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 0.86rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.scv-section-icon {\r\n  font-size: 1rem;\r\n}\r\n\r\n.scv-rows {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.scv-rows.is-nested {\r\n  padding-left: 12px;\r\n  border-left: 2px solid var(--border);\r\n}\r\n\r\n.scv-row {\r\n  display: grid;\r\n  grid-template-columns: 220px minmax(0, 1fr);\r\n  gap: 12px;\r\n  align-items: baseline;\r\n  padding: 3px 0;\r\n  border-bottom: 1px dashed var(--border);\r\n}\r\n\r\n.scv-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.scv-key {\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.scv-val {\r\n  font-size: 0.82rem;\r\n  color: var(--text-primary);\r\n  word-break: break-word;\r\n}\r\n\r\n.scv-chips {\r\n  display: inline-flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n}\r\n\r\n.scv-chip {\r\n  font-size: 0.72rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  padding: 1px 8px;\r\n  color: var(--text-primary);\r\n  background: var(--slate-100);\r\n}\r\n\r\n.scv-bool {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  border-radius: 999px;\r\n  padding: 1px 8px;\r\n}\r\n\r\n/* Verdes/rojos seguros: se leen igual en tema claro y oscuro. */\r\n.scv-bool.is-yes { color: #15803d; background: rgba(22, 163, 74, 0.14); }\r\n.scv-bool.is-no  { color: #991b1b; background: rgba(220, 38, 38, 0.12); }\r\n\r\n.scv-link {\r\n  color: var(--accent);\r\n  text-decoration: none;\r\n  word-break: break-all;\r\n}\r\n\r\n.scv-link:hover { text-decoration: underline; }\r\n\r\n.scv-subblock-title {\r\n  font-size: 0.76rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  margin: 6px 0 2px;\r\n}\r\n\r\n.scv-sublist {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.scv-subrow {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n\r\n.scv-pair {\r\n  font-size: 0.78rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.scv-pair em {\r\n  color: var(--text-secondary);\r\n  font-style: normal;\r\n}\r\n\r\n.scv-empty-state {\r\n  font-size: 0.82rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* En el panel lateral del Diseñador no hay sitio: una columna. */\r\n.sd-detail .scv-row,\r\n.scv-compact .scv-row {\r\n  grid-template-columns: minmax(0, 1fr);\r\n  gap: 2px;\r\n}\r\n\r\n.sd-detail .scv-section,\r\n.scv-compact .scv-section {\r\n  padding: 10px 12px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .scv-row { grid-template-columns: minmax(0, 1fr); gap: 2px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
